<template>
    <div>
        <div class="notoken">一共为您找到<span class="quality">{{mount}}</span>条数据，请<el-button type="primary" size="small" @click="tologin">登录</el-button>后查看</div>
    </div>
</template>
<script>
export default{
    mounted() {

    },
    data() {
        return {
            mount:0
        }
    },
    methods: {
        setmount(aaa) {
            console.log(123,aaa)
            this.mount = aaa
        },
        tologin() {
            this.$router.push({name:'Login'})
        }
    }

}
</script>
<style lang="scss" scoped>
    .notoken {
    text-align: center;
    margin-top: 30px;
    color: #9D9D9D;
    font-size: 18px;
    .quality {
      color: #FFB658;
      font-weight: 600;
      font-size: 25px;
    }
    .el-button--primary {
      background-color: #5D60D1;
      border-radius: 8px;
      margin: 10px;
      font-size: 18px;

    }
  }
        
</style>
    